import {LanguageSwitcherDropdownDefaultBox} from "./language-switcher-dropdown.default.box";

export const LanguageSwitcherDropdownBox = LanguageSwitcherDropdownDefaultBox;
